import { render, staticRenderFns } from "./userDashboardCustomer.vue?vue&type=template&id=401a1dd9&scoped=true"
import script from "./userDashboardCustomer.vue?vue&type=script&lang=js"
export * from "./userDashboardCustomer.vue?vue&type=script&lang=js"
import style0 from "./userDashboardCustomer.vue?vue&type=style&index=0&id=401a1dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a1dd9",
  null
  
)

export default component.exports